import { render, staticRenderFns } from "./ColorDot.demo.vue?vue&type=template&id=1edbe336&"
import script from "./ColorDot.demo.vue?vue&type=script&lang=js&"
export * from "./ColorDot.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports